module.exports = __webpack_public_path__ + "static/media/6.4fb78a5e.webp";